<template>
  <div class="set-monthly-date">
    <div class="man-set-date">
      <div class="man-content">
        <div class="man-content-top">
          <el-row type="flex" class="row-bg" justify="end">
            <el-col :span="6" style="display:flex;">
              <div class="grid-content bg-purple">
                <div
                  v-if="currentYear != setMonthlyYear"
                  class="el-icon-arrow-left sty"
                  @click="changeYear('reduce')"
                />
                <p>{{ setMonthlyYear }}</p>
                <div
                  class="el-icon-arrow-right sty"
                  @click="changeYear('add')"
                />
              </div>
            </el-col>
            <!-- <el-col :span="6">
              <el-button-group>
                <el-button type="info" @click="setNaturalMonth">按自然月统计</el-button>
                <el-button type="success" @click="setSystemDefault">按系统默认区间统计</el-button>
              </el-button-group>
            </el-col> -->
          </el-row>
        </div>
        <div class="man-content-foot">
          <div
            v-for="(smallDate, smallIndex) in manSetData"
            :key="smallIndex"
            ref="setDa"
            class="man-made-date"
          >
            <div class="man-made-top">
              <p>{{ smallIndex | monthType }}：{{ smallIndex + 1 }}月</p>
            </div>
            <div class="man-made-foot">
              <div class="date-content">
                <el-date-picker
                  v-model="value[smallIndex]"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  on-pick
                  @focus="getCurrentMonth(smallIndex)"
                  @change="confirmSetDate"
                />
              </div>
              <div class="date-state">
                <p>
                  当前人工月：
                  <span
                    v-if="smallDate.begin_day"
                  >{{ smallDate.begin_day }} ~ {{ smallDate.end_day }}</span>
                  <span v-else>未设置</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SetMonthlyDate',
  components: {},
  filters: {
    monthType(index) {
      if (index == 0 || index == 1) {
        return '寒假'
      } else if (index == 2 || index == 3 || index == 4 || index == 5) {
        return '春季常规'
      } else if (index == 6 || index == 7) {
        return '暑假'
      } else if (index == 8 || index == 9 || index == 10 || index == 11) {
        return '秋季常规'
      }
    }
  },
  data() {
    return {
      currentYear: '',
      setMonthlyYear: '',
      setMonthlyMonth: '',
      manSetData: [],
      value: []
    }
  },
  mounted() {
    this.getArtificialCalendar()
  },
  created() {
    var date = new Date()
    this.currentYear = date.getFullYear()
    this.setMonthlyYear = this.currentYear
  },
  methods: {
    changeYear(add) {
      if (add == 'reduce') {
        this.setMonthlyYear--
      } else {
        this.setMonthlyYear++
      }
      this.getArtificialCalendar()
    },
    getCurrentMonth(val) {
      this.setMonthlyMonth = val + 1
    },
    confirmSetDate(val) {
      if (val) {
        // if (val[0].substring(0, 4) != this.setMonthlyYear) {
        //   this.$message({
        //     type: "warning",
        //     message: "请先选择正确的年月！"
        //   });
        //   this.value[this.setMonthlyMonth - 1] = ["", ""];
        //   return;
        // }
        const params = {
          month: this.setMonthlyMonth,
          begin_day: val[0],
          end_day: val[1],
          year: this.setMonthlyYear
        }
        this.$http.setArtificialCalendar(params).then(res => {
          this.getArtificialCalendar()
        })
      }
    },
    getArtificialCalendar() {
      this.$http
        .getArtificialCalendar({ year: this.setMonthlyYear })
        .then(res => {
          if (res.data && res.data.length != 0) {
            this.value = []
            this.manSetData = res.data
            this.manSetData.map((item, index) => {
              this.value.push([item.begin_day, item.end_day])
            })
          } else {
            this.value = []
            console.log(this.value)
            this.manSetData = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}]
          }
        })
    }
  }
}
</script>

<style lang="scss">
.man-set-date {
  width: 100%;
  background-color: #ffffff;
  box-shadow: 0px 6px 20px 0px rgba(210, 210, 210, 0.5);
  border-radius: 10px;
  .man-content {
    margin: 0 40px;
    text-align: center;
    .man-content-top {
      line-height: 100px;
      border-bottom: 2px solid #f5f5f5;
      .el-col-6 {
        width: auto;
        margin: 0 20px;
        .el-button {
          padding: 12px 30px;
          border-radius: 6px;
        }
        .el-button--success {
          background-color: #0bc07c;
          margin-left: 20px;
          border-color: #0bc07c;
        }
        .grid-content {
          display: flex;
          justify-content: center;
          align-items: center;
          .sty {
            padding: 10px;
          }
          p {
            padding: 0 10px;
            font-family: PingFangSC-Semibold;
            font-size: 24px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #4c84ff;
          }
        }
      }
    }
  }
}
.man-content-foot {
  display: flex;
  width: 100%;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-top: 50px;
}
.man-made-date {
  margin: 0 40px 60px;
  position: relative;
  .man-made-top {
    width: 170px;
    height: 30px;
    background-color: rgba($color: #4c84ff, $alpha: 0.1);
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    p {
      line-height: 30px;
      font-family: PingFangSC-Medium;
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #4c84ff;
    }
  }
  .man-made-foot {
    width: 370px;
    // height: 106px;
    border-radius: 10px;
    border-top-left-radius: 0px;
    border: solid 2px #edf2ff;
    .date-content {
      margin: 0 20px;
      border-bottom: solid 2px #edf2ff;
      line-height: 56px;
      p {
        font-size: 18px;
        font-family: PingFangSC-Semibold;
        letter-spacing: 0px;
        color: #333333;
        font-weight: bold;
        .const-text {
          padding: 0 40px;
          font-weight: normal;
          color: #999999;
          font-family: PingFangSC-Regular;
        }
      }
    }
    .date-state {
      margin: 0 20px;
      line-height: 44px;
      p {
        text-align: left;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #999999;
      }
    }
  }
  .set-date {
    position: absolute;
    width: max-content;
    z-index: 10;
    background-color: #ffffff;
    box-shadow: 0px 6px 20px 0px rgba(148, 148, 148, 0.5);
    border-radius: 10px;
    .set-date-region {
      display: flex;
      width: 100%;
      border-bottom: solid 1px #f2f2f2;
      .flex-width {
        flex: 1;
        padding: 45px 50px 21px;
        .lable {
          font-family: PingFangSC-Semibold;
          font-size: 18px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #4c84ff;
          margin-bottom: 20px;
        }
        .el-col-6 {
          width: auto;
          white-space: nowrap;
          .grid-content {
            background-color: rgba($color: #4c84ff, $alpha: 0.1);
            border-radius: 25px;
            line-height: 40px;
            .el-icon-caret-left {
              color: #4c84ff;
              margin: 0 18px;
            }
            .span-text {
              font-family: PingFangSC-Medium;
              font-size: 16px;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              color: #4c84ff;
            }
            .el-icon-caret-right {
              color: #4c84ff;
              margin: 0 18px;
            }
          }
        }
        .days {
          // margin-top: 10px;
          .item {
            float: left;
            width: 50px;
            text-align: center;
            height: 50px;
            p {
              font-family: PingFangSC-Semibold;
              font-size: 18px;
              letter-spacing: 0px;
              color: #4c84ff;
            }
          }
          .week {
            display: inline-flex;
            .item {
              line-height: 50px;
            }
          }
          .dayList {
            display: inline-flex;
            .item {
              display: flex;
              p {
                width: 34px;
                height: 34px;
                border-radius: 50%;
                color: #333;
                margin: auto;
                line-height: 34px;
                cursor: pointer;
              }
              .bg-blue {
                background-color: #4c84ff;
                color: #fff;
              }
              .text-none {
                display: none;
              }
            }
          }
        }
      }
    }
    .edit-btn {
      width: 100%;
      margin: 20px 0;
      .el-col-6 {
        width: auto;
        .el-button--info {
          background-color: #999;
          border-color: #999;
          font-size: 16px;
          margin-right: 20px;
        }
        .el-button--primary {
          background-color: #4c84ff;
          border-color: #4c84ff;
          font-size: 16px;
        }
      }
    }
  }
  .set-left {
    left: 0;
  }
  .set-center {
    left: 0;
    margin-left: -70%;
  }
  .set-right {
    right: 0;
  }
}
.el-date-editor.el-range-editor.el-input__inner.el-date-editor--daterange {
  width: 325px;
  border: none;
}
.el-date-editor .el-range-input,
.el-date-editor .el-range-separator {
  font-size: 19px;
  color: #333333;
  input {
    width: 100%;
  }
}
</style>
